import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-3xl"
};
import LoadingLayout from "@/modules/base/layouts/LoadingLayout.vue";
import { Season } from "@/modules/season/entity";
import { Team } from "@/modules/team/entity";
import { Match } from "@/modules/match/entity";
import MatchPanel from "@/modules/diplomacy/components/MatchPanel.vue";
import { app } from "@/di";
import { DayEvaluator } from "@/modules/season/services/DayEvaluator";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchEvaluationBefore',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const router = useRouter();
    const nextMatch = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      nextMatch.value = await Match.findNext(await Season.current(), await Team.current());
    })), __temp = await __temp, __restore(), __temp);
    const dayEvaluator = app.get(DayEvaluator);
    onMounted(async () => {
      await dayEvaluator.evaluate();
    });
    watch(() => route.query, async () => {
      if (route.query.ready) {
        await waitFor(1000); // todo really needed? with regular amount of teams, too slow?
        router.push({
          name: 'matches.evaluation',
          params: route.params
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(LoadingLayout, {
        "hide-loader": ""
      }, {
        default: _withCtx(() => [_createVNode(MatchPanel, {
          match: nextMatch.value,
          class: "my-8 w-full"
        }, null, 8, ["match"]), _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('starting_match')), 1)]),
        _: 1
      });
    };
  }
});